import { MediaEntity } from '@/modules/medias/domain/entities/MediaEntity';
import { requestQuery } from '@/services/request';
import { MediaPlayBackUrl } from '@/types';

export const getMediasProgram = async (programUUID: string) => {
  if (!programUUID) return;

  const response = await requestQuery<MediaPlayBackUrl[]>({
    url: `player/programs/${programUUID}/medias`,
  });

  return (response || []).map(
    (d) =>
      new MediaEntity({
        ...d.media,
        domain: d.source,
        playbackURL: d.permanentPlaybackURL,
      })
  );
};
